<template>
  <div class="error-page container">
    <div class="error-page-content">
      <div class="error-page-title">
        <h1>Ooopsss! Сталась помилка :(</h1>
      </div>
      <div class="error-page-subTitle">
        <p>Вибачте, ми не можемо знайти цю сторінку.</p>
      </div>
      <div class="error-page-btn">
        <button class="rounded-btn blue" @click="$router.push({ path: '/' })">
          <span>На головну</span>
          <IconBase height="10" width="10"><ArrowRight /></IconBase>
        </button>
      </div>
       <div class="error-page-mobile-img hidden-sm-and-up ">
      <img src="@/assets/images/mobile/bg-404.png" alt="" />
    </div>
      <div class="error-page-main-img hidden-xs-only">
        <img src="@/assets/images/404-main-img.png" alt="" />
      </div>
    </div>
    <!--    background-->

   
    <div class="error-page-left-img hidden-xs-only">
      <img src="@/assets/images/404-left-img.png" alt="" />
    </div>
    <div class="error-page-left-cloud hidden-xs-only">
      <img src="@/assets/images/404-cloud-left.png" alt="" />
    </div>
    <div class="error-page-right-img hidden-xs-only">
      <img src="@/assets/images/main-right-top.png" alt="" />
    </div>
    <div class="error-page-right-cloud hidden-xs-only">
      <img src="@/assets/images/404-cloud.png" alt="" />
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import ArrowRight from '@/components/icons/ArrowRight'
export default {
  name: 'PageError',
  components: { ArrowRight, IconBase },
}
</script>
